import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  authButton: {
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    borderRadius: '20px !important',
  },
}));

export default useStyles;
